import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";


const {ccclass, property} = cc._decorator;

@ccclass
export  class RoadMap_cp_item extends cc.Component {
    
    @property(cc.Sprite)
    spriteNum: cc.Sprite = null

    @property(cc.Sprite)
    spriteBg: cc.Sprite = null

    @property(SpriteFrameHolder)
    spriteHolderNum: SpriteFrameHolder = null

    @property(SpriteFrameHolder)
    spriteHolderColor: SpriteFrameHolder = null

    @property(cc.Animation)
    animAppear: cc.Animation = null

    @property(cc.Node)
    nodeDisappear: cc.Node = null

    @property(cc.Node)
    nodePaiZi: cc.Node = null

    playAppearEffect(onFinish){
        this.nodeDisappear.active = false
        // this.animAppear.stop()
        // this.animAppear.play('anim_lishi_come')
        // this.scheduleOnce(()=>{
        //     onFinish && onFinish()
        // }, 0.5)
        let anim1 = cc.scaleTo(0.267, 1.4)
        let anim2 = cc.scaleTo(0.1, 1)
        this.nodePaiZi.scale = 1
        this.nodePaiZi.opacity = 255
        this.node.scale = 0
        this.animAppear.stop('anim_lishi_out')
        let node = this.node
        let lastAction = node['_lastAppearAction']
        lastAction && node.stopAction(lastAction)
        let action = cc.sequence([anim1, anim2, cc.callFunc(function(){
            node['_lastAppearAction'] = null
            onFinish && onFinish()
        })])
        node['_lastAppearAction'] = action
        node.active = true
        node.runAction(action)
        
    }

    playDisappear(onFinish){
        this.nodeDisappear.active = true
        this.animAppear.play('anim_lishi_out')
        this.scheduleOnce(()=>{
            onFinish && onFinish()
        }, 0.78)
    }

    setData(num: number){
        this.spriteBg.spriteFrame = this.spriteHolderColor.getSpriteFrameByKey(num.toString())
        this.spriteNum.spriteFrame = this.spriteHolderNum.getSpriteFrameByKey(num.toString())
    }

}
